import { ChartIncreaseIcon } from "@/domains/icons"

import { EpochIcon } from "@/domains/icons/huge-icons/monotone/epoch"
import { ComplexBreadcrumbItem } from "../../types/complex-breadcrumb-item"
import type { ComplexTab } from "../complex-breadcrumb-dropdown"
import { ComplexBreadcrumbDropdown } from "../complex-breadcrumb-dropdown"

// Available Analytics pages
export const ANALYTICS_PAGES: ComplexTab[] = [
  {
    id: "epochs",
    label: "Epochs",
    tabLabel: "Epochs",
    description: "Protocol epoch analytics",
    slug: "/analytics/epochs",
    icon: EpochIcon,
  },
  {
    id: "volume",
    label: "Volume",
    tabLabel: "Volume",
    description: "Platform volume analytics",
    slug: "/analytics/volume",
    icon: ChartIncreaseIcon,
  },
] as const

export const AnalyticsPagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "analytics-pages",
  render: () => <AnalyticsPagesComplexBreadcrumbApplicationComponent />,
}

/**
 * Complex breadcrumb application for Analytics pages
 * Shows current page name and allows navigation to other Analytics pages
 */
export const AnalyticsPagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown
      tabs={ANALYTICS_PAGES}
      navigationMode="path"
      invalidTabMessage="Invalid analytics page"
    />
  )
}
